import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';

export interface FileUploadResponse {
  uploadUrl: string;
  objectKey: string;
  originalFilename: string;
}

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  async uploadFiles(endpoint: string, files: File[]) {
    const user = await firstValueFrom(this.authService.getUserObject());
    const response = await firstValueFrom(
      this.http.post<FileUploadResponse[]>(endpoint, {
        files: files.map((file) => ({
          originalFilename: file.name,
          fileExtension: file.name.split('.').pop(),
        })),
      }),
    );
    const promises = [];
    for (const url of response) {
      const file = files.find((file) => file.name === url.originalFilename);
      const blob = new Blob([file], { type: file.type });
      const headers = new HttpHeaders({
        'Content-Type': file.type,
        'x-goog-meta-uploadedBy': user?.uid,
        'x-goog-meta-blobName': url?.objectKey,
      });
      promises.push(
        firstValueFrom(
          this.http.put(url.uploadUrl, blob, { headers, responseType: 'text' }),
        ),
      );
    }
    await Promise.all(promises);
    return response;
  }

  uploadComplete(endpoint: string, files: File[]) {
    return this.http.post(endpoint, {
      files: files.map((file) => ({
        originalFilename: file.name,
        fileExtension: file.name.split('.').pop(),
      })),
    });
  }
}
